/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MongoFileChunk model module.
 * @module model/MongoFileChunk
 * @version v1.0.0
 */
class MongoFileChunk {
    /**
     * Constructs a new <code>MongoFileChunk</code>.
     * @alias module:model/MongoFileChunk
     */
    constructor() { 
        
        MongoFileChunk.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MongoFileChunk</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MongoFileChunk} obj Optional instance to populate.
     * @return {module:model/MongoFileChunk} The populated <code>MongoFileChunk</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MongoFileChunk();

            if (data.hasOwnProperty('bookIsbn')) {
                obj['bookIsbn'] = ApiClient.convertToType(data['bookIsbn'], 'String');
            }
            if (data.hasOwnProperty('bookType')) {
                obj['bookType'] = ApiClient.convertToType(data['bookType'], 'String');
            }
            if (data.hasOwnProperty('chunkName')) {
                obj['chunkName'] = ApiClient.convertToType(data['chunkName'], 'String');
            }
            if (data.hasOwnProperty('chunkNum')) {
                obj['chunkNum'] = ApiClient.convertToType(data['chunkNum'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('createdBy')) {
                obj['createdBy'] = ApiClient.convertToType(data['createdBy'], 'Number');
            }
            if (data.hasOwnProperty('dbDelete')) {
                obj['dbDelete'] = ApiClient.convertToType(data['dbDelete'], 'Boolean');
            }
            if (data.hasOwnProperty('end')) {
                obj['end'] = ApiClient.convertToType(data['end'], 'Number');
            }
            if (data.hasOwnProperty('fileHash')) {
                obj['fileHash'] = ApiClient.convertToType(data['fileHash'], 'String');
            }
            if (data.hasOwnProperty('fileName')) {
                obj['fileName'] = ApiClient.convertToType(data['fileName'], 'String');
            }
            if (data.hasOwnProperty('fullPath')) {
                obj['fullPath'] = ApiClient.convertToType(data['fullPath'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('index')) {
                obj['index'] = ApiClient.convertToType(data['index'], 'Number');
            }
            if (data.hasOwnProperty('start')) {
                obj['start'] = ApiClient.convertToType(data['start'], 'Number');
            }
            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedBy')) {
                obj['updatedBy'] = ApiClient.convertToType(data['updatedBy'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} bookIsbn
 */
MongoFileChunk.prototype['bookIsbn'] = undefined;

/**
 * @member {String} bookType
 */
MongoFileChunk.prototype['bookType'] = undefined;

/**
 * @member {String} chunkName
 */
MongoFileChunk.prototype['chunkName'] = undefined;

/**
 * @member {Number} chunkNum
 */
MongoFileChunk.prototype['chunkNum'] = undefined;

/**
 * @member {Date} createdAt
 */
MongoFileChunk.prototype['createdAt'] = undefined;

/**
 * @member {Number} createdBy
 */
MongoFileChunk.prototype['createdBy'] = undefined;

/**
 * @member {Boolean} dbDelete
 */
MongoFileChunk.prototype['dbDelete'] = undefined;

/**
 * @member {Number} end
 */
MongoFileChunk.prototype['end'] = undefined;

/**
 * @member {String} fileHash
 */
MongoFileChunk.prototype['fileHash'] = undefined;

/**
 * @member {String} fileName
 */
MongoFileChunk.prototype['fileName'] = undefined;

/**
 * @member {String} fullPath
 */
MongoFileChunk.prototype['fullPath'] = undefined;

/**
 * @member {String} id
 */
MongoFileChunk.prototype['id'] = undefined;

/**
 * @member {Number} index
 */
MongoFileChunk.prototype['index'] = undefined;

/**
 * @member {Number} start
 */
MongoFileChunk.prototype['start'] = undefined;

/**
 * @member {Number} total
 */
MongoFileChunk.prototype['total'] = undefined;

/**
 * @member {Date} updatedAt
 */
MongoFileChunk.prototype['updatedAt'] = undefined;

/**
 * @member {Number} updatedBy
 */
MongoFileChunk.prototype['updatedBy'] = undefined;

/**
 * @member {Number} userId
 */
MongoFileChunk.prototype['userId'] = undefined;






export default MongoFileChunk;

